import { lazy } from "react";

const list = lazy(() => import("./List").then(m => ({ default: m.FirmList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.FirmCreate })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.FirmEdit })));

export default { list, create, edit };
